import { jsx as _jsx } from "react/jsx-runtime";
import { Center } from '@chakra-ui/react';

const CUICenter = args => {
  return /*#__PURE__*/_jsx(Center, Object.assign({}, args));
};

export default CUICenter;